import { Card, CardContent, Typography } from '@material-ui/core';
import React from 'react';



const TechDetail = ({ user, onClick, selected = false  }) => {
   
  return (
    <Card elevation={6}  style={{ marginBottom: "10px",
      backgroundColor: selected ? 'green' : '',
      color: selected ? 'white' : '',
    }}
    onClick={onClick} >
      <CardContent style={{ height: "10px" }}>
        <Typography style={{  alignItems: "center", justifyContent: "center" }} >
          {user}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default TechDetail;